module.exports = __webpack_public_path__ + "static/media/kim.2bdee244.jpg";